import { TableBody, TableCell, TableHead } from "@material-ui/core";
import {
  CollapseGroupRows,
  DefaultTable,
  FirstCell,
  NestedRow,
  TextCell,
} from "@View/common/table";
import React from "react";
import { useTranslation } from "react-i18next";
import pickColor from "@Utils/colorPicker";

const AnalysisTable = ({ data, dates, curency }) => {
  const { i18n } = useTranslation();

  const formatCurrency = (number) => {
    return i18n.language === "en"
      ? new Intl.NumberFormat().format(number)
      : new Intl.NumberFormat("ru", {
          style: "decimal",
        }).format(number);
  };

  function generateTableData(data, level = 2) {
    return data.map((el, index) => {
      if (Array.isArray(el.subRows) && el.subRows.length) {
        return (
          <CollapseGroupRows
            level={level}
            key={`${el.titleRow}-${index}`}
            clickableCellText={el.titleRow}
            otherCellsTexts={[""].concat(
              el.rowValues.map((v) => formatCurrency(v.value))
            )}
          >
            {generateTableData(el.subRows, level + 1)}
          </CollapseGroupRows>
        );
      }
      return (
        <NestedRow key={`sub-${el.titleRow}-${index}`}>
          <FirstCell paddingLeft={`calc(${level}em + 5px)`}>{el.titleRow}</FirstCell>
          <TextCell></TextCell>
          {el.rowValues.map((e) => {
            return (
              <TextCell align="right" color={pickColor(e.color)}>
                {formatCurrency(e.value)}
              </TextCell>
            );
          })}
        </NestedRow>
      );
    });
  }

  return (
    <DefaultTable nested={false} id="DynamicsCurrencyTable">
      <TableHead
        style={{
          background: "#F3F5F7",
          height: "46px",
        }}
      >
        <NestedRow>
          <TableCell
            style={{
              paddingLeft: "4em",
              textAlign: "left",
              border: "none",
              fontWeight: 600,
              fontSize: "13px",
              lineHeight: "16px",
              letterSpacing: "0.0075em",
              color: "#54606F",
            }}
          ></TableCell>
          <TextCell>{curency}</TextCell>
          {dates.map((el) => {
            return (
              <TextCell
                key={el.columnName}
                additionStyles={{ minWidth: "130px" }}
                importantTextAlign="right"
              >
                {el.columnName}
              </TextCell>
            );
          })}
        </NestedRow>
      </TableHead>
      <TableBody>{generateTableData(data)}</TableBody>
    </DefaultTable>
  );
};

export default AnalysisTable;
